/* global window */

/* eslint-disable import/extensions */
import {
    createAnalytics,
    defineEvents,
    SHARED_EVENTS,
    createIdentityJwtTokenGetter
} from '@3plearning/mx-teacher-analytics';
/* eslint-enable import/extensions */

import UrlHelper from './url-helper';
import { localeCode } from './locale-helpers';

const APP_NAME = 'student-reports';
const TEACHER_TOTTER_PRODUCT = 'mathletics';

export const ANALYTICS_EVENTS = {
    pageView: 'page.view',
    sectionError: 'section.error',
    reportView: 'report.view',
    filterChanged: 'filter.changed',
    reportExported: 'report.exported',
    reportDownloaded: 'report.downloaded'
};

const appEvents = defineEvents({
    ...SHARED_EVENTS,
    [ANALYTICS_EVENTS.reportView]: { group: 'reports', props: {} },
    [ANALYTICS_EVENTS.filterChanged]: { group: 'filters', props: {} },
    [ANALYTICS_EVENTS.reportExported]: { group: 'export', props: {} },
    [ANALYTICS_EVENTS.reportDownloaded]: { group: 'export', props: {} }
});

function readEnv(key) {
    // eslint-disable-next-line no-underscore-dangle
    const config = window._env_;
    return config ? config[key] : undefined;
}

function getParam(key) {
    return UrlHelper.getQueryParamValue(key) || '';
}

function getIdentity() {
    return {
        locale: localeCode(),
        countryCode: getParam('countryCode'),
        userProfileId: getParam('userProfileId'),
        userProfileType: 'teacher',
        marketRegionId: getParam('regionId')
    };
}

function isTeacherTotterEnabled() {
    return (
        readEnv('TeacherTotterEnabled') === 'true' &&
        getParam('isOneRosterActivatedSchool') === 'true'
    );
}

let client = null;

export function getAnalytics() {
    if (client) {
        return client;
    }

    const environment = readEnv('env') || getParam('env') || 'live';

    client = createAnalytics({
        app: APP_NAME,
        environment,
        providers: {
            posthog: { enabled: readEnv('PostHogEnabled') === 'true' },
            teacherTotter: {
                enabled: isTeacherTotterEnabled(),
                syncUrl: readEnv('AnalyticsTeacherTotterSyncUrl') || '',
                product: TEACHER_TOTTER_PRODUCT,
                getAuthToken: createIdentityJwtTokenGetter({
                    identityGatewayUrl:
                        readEnv('AnalyticsIdentityGatewayUrl') || '',
                    getAppAuthToken: () => getParam('authToken') || null
                })
            }
        },
        enabledFeatureGroups: null,
        events: appEvents
    });

    client.setCommonProps(getIdentity());
    client.identify();

    return client;
}

// Analytics must never interrupt a teacher's flow, so failures are swallowed.
export function trackEvent(name, props = {}) {
    try {
        const result = getAnalytics().track(name, props);
        if (result && typeof result.catch === 'function') {
            result.catch(() => {});
        }
    } catch (err) {
        // no-op
    }
}

export function trackSession(task) {
    try {
        getAnalytics().trackSession(task);
    } catch (err) {
        // no-op
    }
}



// WEBPACK FOOTER //
// ./helpers/analytics.js